import { extractErrorMessages } from '@fukuri-admins/ui/common/Form/logics/extractErrorMessages';
import React, { ComponentProps } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { FileUploadField } from '..';

type FileUploadFieldProps = ComponentProps<typeof FileUploadField>;

type Props = {
  name: string;
  fileUpload: Omit<FileUploadFieldProps['fileUpload'], 'value' | 'onChange'>;
  fieldWrapperProps: Omit<FileUploadFieldProps['fieldWrapperProps'], 'htmlFor' | 'errorMessages'>;
  /**
   * 単一ファイル（single）選択時に、ファイルが明示的に削除されたときのコールバック。
   * onChange(undefined) が呼ばれた = ユーザーが削除ボタンを押した、と判断して呼び出す。
   */
  onRemove?: () => void;
};

export const FileUploadFieldController: React.FC<Props> = ({
  name,
  fileUpload,
  fieldWrapperProps,
  onRemove,
}) => {
  const { control } = useFormContext();
  const {
    field,
    fieldState: { error },
  } = useController({ control, name });

  // field.value / field.onChange は useFormContext 経由のため any 型。
  // FileUpload プリミティブの Discriminated Union が実行時に型安全性を担保し、
  // RHF 側は any を受け付けるため、as なしでそのまま渡す。
  const handleChange = (value: unknown) => {
    if (value === undefined && fileUpload.isMultiple !== true) {
      onRemove?.();
    }
    field.onChange(value);
  };

  const fileUploadProps = {
    ...fileUpload,
    value: field.value ?? (fileUpload.isMultiple ? [] : undefined),
    onChange: handleChange,
  };

  return (
    <FileUploadField
      fileUpload={fileUploadProps}
      fieldWrapperProps={{
        htmlFor: name,
        errorMessages: extractErrorMessages(error),
        ...fieldWrapperProps,
      }}
    />
  );
};
